import { Grid } from 'foundations-components/transitional/components/Grid';
import { InfoPanelHeader } from './InfoPanelHeader';
import { Flex } from 'foundations-components/components/Flex';
import { InfoGridRow } from './InfoGridRow';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import I18n from 'I18n';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { usePortalData } from '../../data/usePortalData';
import { GridItem } from 'foundations-components/transitional/components/Grid';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { FavoriteHollowIcon } from 'foundations-assets/icons/components/FavoriteHollowIcon';
import { View } from 'foundations-components/transitional/components/View';
import { useTicket } from '../../data/useTicket';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const TicketInfoGrid = ({
  ticketId,
  configuredTicketProperties,
  stageIsConfigured = false,
  loading,
  error,
  refetchTicket
}) => {
  var _portalData$settings;
  const {
    data: portalData
  } = usePortalData();
  const {
    data: ticket
  } = useTicket(Number(ticketId));
  const customStageNameEnabled = (portalData === null || portalData === void 0 || (_portalData$settings = portalData.settings) === null || _portalData$settings === void 0 ? void 0 : _portalData$settings.ticketStagesDisplayType) === 'CUSTOM_STAGE_NAMES';
  const appendCustomStageName = !stageIsConfigured && customStageNameEnabled;
  const customStageName = (ticket === null || ticket === void 0 ? void 0 : ticket['hs_pipeline_stage']) || '';
  const handleTryAgain = () => {
    void refetchTicket();
  };
  if (loading) {
    return /*#__PURE__*/_jsx(Flex, {
      flexDirection: "column",
      inlineSize: "100%",
      alignItems: "center",
      justifyContent: "center",
      children: /*#__PURE__*/_jsx(LoadingSpinner, {
        "aria-label": I18n.text('customer-portal-app.loading')
      })
    });
  }
  if (error) {
    return /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      paddingInlineEnd: "400",
      alignItems: "center",
      justifyContent: "center",
      gap: "400",
      children: [/*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        children: [/*#__PURE__*/_jsx(Text, {
          as: "h1",
          typography: "body-100",
          marginBlockEnd: "0",
          children: I18n.text('customer-portal-app.ticketInfoPanel.error')
        }), /*#__PURE__*/_jsx(Text, {
          as: "h2",
          typography: "body-100",
          color: "text-core-subtle",
          marginBlockEnd: "0",
          children: I18n.text('customer-portal-app.ticketInfoPanel.refreshPage')
        })]
      }), /*#__PURE__*/_jsx(Button, {
        use: "primary",
        onClick: handleTryAgain,
        children: I18n.text('customer-portal-app.ticketInfoPanel.tryAgain')
      })]
    });
  }
  return /*#__PURE__*/_jsxs(View, {
    as: "div",
    color: "text-core-default",
    children: [/*#__PURE__*/_jsx(InfoPanelHeader, {
      ticketId: ticketId
    }), /*#__PURE__*/_jsx(Flex, {
      flexDirection: "column",
      marginBlockStart: "400",
      paddingInlineEnd: "400",
      children: /*#__PURE__*/_jsxs(Grid, {
        inlineSize: "100%",
        rowGap: "600",
        children: [configuredTicketProperties === null || configuredTicketProperties === void 0 ? void 0 : configuredTicketProperties.map(configuredTicketProperty => /*#__PURE__*/_jsx(InfoGridRow, {
          configuredTicketProperty: configuredTicketProperty
        }, configuredTicketProperty.propertyName)), appendCustomStageName && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(GridItem, {
            size: 6,
            children: /*#__PURE__*/_jsxs(Flex, {
              flexDirection: "row",
              gap: "200",
              alignItems: "center",
              children: [/*#__PURE__*/_jsx(Flex, {
                flexShrink: "0",
                children: /*#__PURE__*/_jsx(FavoriteHollowIcon, {
                  size: "300"
                })
              }), /*#__PURE__*/_jsx(Text, {
                as: "div",
                typography: "body-100",
                color: "text-core-subtle",
                marginBlockEnd: "0",
                truncate: true,
                children: /*#__PURE__*/_jsx(TruncateString, {
                  children: I18n.text('customer-portal-app.ticketInfoPanel.stage')
                })
              })]
            })
          }), /*#__PURE__*/_jsx(GridItem, {
            size: 6,
            children: /*#__PURE__*/_jsx(Text, {
              as: "div",
              typography: "body-100",
              color: "text-core-default",
              marginBlockEnd: "0",
              children: customStageName
            })
          })]
        })]
      })
    })]
  });
};